import React from "react";
import { EnhancedImage } from "../../../../components/EnhancedImage";
import "./style.css";

export const TargetBodyType = ({
    clickNext = () => {}, 
    getList, 
    isImagesLoaded = true,
    loadingImages = new Set()
}) => {
  return (
    <div className="target-body-type" data-model-id="16805:7069">

      <div className="frame-4">
        <div className="title">
          <p className="heading">Choose the body you want</p>
        </div>

        <div className="frame-5">
          {getList()?.map((item, index) => {
            const isImageLoading = loadingImages.has(item.image);
            return <div 
              className={`list ${isImageLoading ? 'loading' : ''}`} 
              onClick={() => {clickNext(item.value)}} 
              key={index}
            >
              <div className="text-wrapper">{item.title}</div>

              {/* Only show image after it's loaded to avoid flickering */}
              {isImagesLoaded && (
                <EnhancedImage 
                  src={item.image} 
                  alt="Body type image" 
                  className="image"
                  fadeInOnLoad={true}
                  showLoadingPlaceholder={false}
                  defaultLoad={true}
                />
              )}
              
              {/* Placeholder while loading */}
              {!isImagesLoaded && (
                <div className="image-placeholder" />
              )}
            </div>
          })}
        </div>
      </div>
    </div>
  );
};
